// extracted by mini-css-extract-plugin
export default {"root":"Pill_root__gNqnE"};